<div class="resetPasswordContainer">
    <div class="card">
        <div class="card-body">
            <div class="resetPasswordHeader">
                <h2>{{ 'register.resetPass' | translate }}</h2>
               <p>{{ 'register.resetPass-desc' | translate }}</p> 
           </div>
            <form [formGroup]="resetPasswordForm">
                <div class="form-group col">
                    <label>{{ 'register.newPass' | translate }}</label>
                    <input type="password" formControlName="password" class="form-control" placeholder="{{ 'register.typeNewPass' | translate }}" [ngClass]="{'input-error': resetPasswordForm.touched && resetPasswordForm.controls['password'].errors}">
                    <div *ngIf="resetPasswordForm.touched && resetPasswordForm.controls['password'].errors" class="invalid-feedback">
                        <div *ngIf="resetPass.password.errors.required">{{ 'register.password_req' | translate }}</div>
                        <div *ngIf="resetPass.password.errors.minlength">{{ 'register.password_valid' | translate }}</div>
                    </div>
                </div>
                <div class="form-group col">
                    <input type="password" formControlName="password_confirmation" class="form-control" placeholder="{{ 'register.confirmNewPass' | translate }}" [ngClass]="{'input-error': resetPasswordForm.controls['password_confirmation'].touched && resetPasswordForm.controls['password_confirmation'].errors}">
                    <div *ngIf="resetPasswordForm.controls['password_confirmation'].touched && resetPasswordForm.controls['password_confirmation'].errors" class="invalid-feedback">
                        <div *ngIf="resetPasswordForm.controls['password_confirmation'].errors.required">{{ 'register.password_confirm_req' | translate }}</div>
                        <div *ngIf="resetPasswordForm.controls['password_confirmation'].errors.PasswordValidator">{{ 'register.password_confirm_valid' | translate }}</div>
                    </div>
                    <div *ngIf="resetPasswordForm.controls['email'].touched && resetPasswordForm.controls['email'].errors" class="invalid-feedback">
                        <div *ngIf="resetPasswordForm.controls['email'].errors.required">Email missing.</div>
                    </div>
                    <div *ngIf="resetPasswordForm.controls['token'].touched && resetPasswordForm.controls['token'].errors" class="invalid-feedback">
                        <div *ngIf="resetPasswordForm.controls['token'].errors.required">Token missing.</div>
                    </div>
                </div>
                <div class="form-group col">
                    <button type="submit" class="btn btn-primary btn-block" (click)="onSubmit()">{{ 'register.save' | translate }}</button>
                </div>
            </form>
        </div>  
    </div>
</div>